import { EventNames } from '@iheartjane/tracking';
import { useEffect } from 'react';

import { track } from '@jane/shared-ecomm/tracking';
import { getJaneDeviceId } from '@jane/shared/util';

import { useCustomerDispatch } from '@jane/monolith/customer/dispatch';
import { setJaneDeviceId } from '@jane/monolith/customer/redux/application';

export const useSetJaneDeviceId = () => {
  const dispatch = useCustomerDispatch();

  useEffect(() => {
    const getJaneId = async () => {
      const janeDeviceId = getJaneDeviceId() || '';
      dispatch(setJaneDeviceId({ janeDeviceId }));
      window['janeDeviceId'] = janeDeviceId;
    };

    getJaneId().catch(() => track({ event: EventNames.TimedGetJaneDeviceId }));
  }, []);
};
